import { arrayMove } from "@dnd-kit/sortable";

/**
 * Reorder an array of items with an ``order`` field so that after moving the
 * item at ``oldIndex`` to ``newIndex`` every item's ``order`` value equals
 * its new zero-based position in the array.
 *
 * The backend's checklist normaliser sorts by ``order`` before renumbering,
 * so we MUST renumber before sending — otherwise the pre-drag ``order``
 * values win and the drag has no effect after reload.
 */
export function reorderWithOrderField(items, oldIndex, newIndex) {
  if (oldIndex === newIndex) return items.map((it, i) => ({ ...it, order: i }));
  return arrayMove(items, oldIndex, newIndex).map((it, i) => ({ ...it, order: i }));
}
